import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

// Client-side canonical redirects (P8). True server-side 301s are host-level
// and documented separately; this keeps one canonical URL per page in-app.
const SERVICE_CANONICAL = {
  plumbing: '/plumbing',
  heating: '/heating',
  'air-conditioning': '/air-conditioning',
  'gas-fitting': '/gas-fitting',
  'backflow-testing': '/plumbing/backflow-testing-calgary',
};

export const ServiceRedirect = () => {
  const { serviceType } = useParams();
  const target = SERVICE_CANONICAL[serviceType] || '/services';
  return <Navigate to={target} replace />;
};

export default ServiceRedirect;
